import { PropuestaEnConstruccionProvider } from '@/lib/PropuestaEnConstruccionContext';
import { Outlet } from 'react-router-dom';

/**
 * Envuelve la sub-sección de Propuestas de pago (no Vencimientos, que es
 * solo lectura) con el contexto de la "canasta" en construcción, para que
 * la selección de facturas sobreviva mientras el usuario navega entre la
 * pantalla de criterio, el listado y el detalle de una propuesta.
 */
export function PropuestasPagoLayout() {
  return (
    <PropuestaEnConstruccionProvider>
      <Outlet />
    </PropuestaEnConstruccionProvider>
  );
}
